import React, { useRef, useState, useEffect, useCallback, useContext } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { Fieldset } from 'primereact/fieldset';
import { useParams } from "react-router-dom";
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Skeleton } from 'primereact/skeleton';
import { useFormik } from 'formik';
import { AuthContext } from '../contexts/AuthContext';
import * as Yup from 'yup';

import { ErrorValidationMessage } from './ErrorValidationMessage';

import api from '../api/api';

import '../layout/sass/_form.scss';

export const FormEmpenhoInstalacao = ({ isEditing, isLoading, setListInstalacaoEmpenho, setPendingImportData }) => {

    const { id } = useParams();
    const { anoRef, fornecedorNome } = useContext(AuthContext);
    const [listEmpenhos, setListEmpenhos] = useState([]);
    const [isLoadingInstalacoes, setIsLoadingInstalacoes] = useState(false);
    const toast = useRef(null);
    const [isSubmiting, setIsSubmiting] = useState(false)
    const [listInstalacao, setListInstalacao] = useState(false);
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const containerStyle = {
        display: 'flex',
        gap: '1rem',
        flexWrap: 'wrap'
    };

    const handleImportEmpenho = async () => {
        if (!selectedEmpenho) return;

        setIsLoadingInstalacoes(true);

        try {
            const response = await api.get(`instalacaoEmpenho/empenho/${selectedEmpenho.id}`);
            const instalacoesAtivas = response.data.filter(item => item.ativo);

            if (instalacoesAtivas.length === 0) {
                toast.current.show({
                    severity: 'warn',
                    summary: 'Aviso',
                    detail: 'Nenhuma instalação ativa encontrada para este empenho',
                    life: 3000
                });
                return;
            }

            const novasInstalacoes = instalacoesAtivas.map(instalacao => ({
                ativo: true,
                empenhoAnoRef: selectedEmpenho.anoRef,
                empenhoId: id,
                instalacaoId: instalacao.instalacaoId,
                instalacaoNumero: instalacao.instalacaoNumero,
                numeroEmpenho: selectedEmpenho.numeroEmpenho,
                peso: instalacao.peso,
                saldoEmpenho: selectedEmpenho.saldoEmpenho
            }));

            setListInstalacaoEmpenho(prev => [...prev, ...novasInstalacoes]);

            setPendingImportData({
                empenhoId: selectedEmpenho.id,
                instalacoesAtivas: novasInstalacoes,
                count: novasInstalacoes.length
            });

            toast.current.show({
                severity: 'success',
                summary: 'Importação concluída',
                detail: `${novasInstalacoes.length} instalações importadas`,
                life: 3000
            });

        } catch (error) {
            console.error('Erro ao buscar instalações:', error);
            toast.current.show({
                severity: 'error',
                summary: 'Erro',
                detail: 'Falha ao buscar instalações',
                life: 3000
            });
        } finally {
            setIsLoadingInstalacoes(false);
        }
    };

    const handleGetEmpenhos = useCallback(async () => {
        if (fornecedorNome === "TODOS" || anoRef === 0) {
            await api.get("empenho/empenhoAll").then((response) => {
                const empenhos = response.data.map(item => {
                    return {
                        id: item.id,
                        numeroEmpenho: item.numeroEmpenho,
                        ficha: item.ficha,
                        fonte: item.fonte,
                        valorEmpenho: item.valorEmpenho,
                        secretariaId: item.secretariaId,
                        anoRef: item.anoRef
                    }
                });
                setListEmpenhos(empenhos);
            });
        } else {
            
            const pesquisa = {
                "fornecedorNome": fornecedorNome,
                "anoRef": anoRef,
            }

            const respEmpenhos = await api.post(`empenho/searchEmpenho/ASC/id?`, pesquisa);
            const empenhosData = respEmpenhos.data.content.map(empenho => ({
                id: empenho.id,
                numeroEmpenho: empenho.numeroEmpenho,
                ficha: empenho.ficha,
                fonte: empenho.fonte,
                valorEmpenho: empenho.valorEmpenho,
                secretariaId: empenho.secretariaId,
                anoRef: empenho.anoRef
            }));
            setListEmpenhos(empenhosData);
        }
    }, [fornecedorNome, anoRef]);

    useEffect(() => {
        handleGetEmpenhos();
    }, [handleGetEmpenhos]);

    const [selectedEmpenho, setSelectedEmpenho] = useState(null);

    const fieldsetStyle = {
        flex: '1',
        minWidth: '300px'
    };

    const schema = Yup.object().shape({
        peso: Yup
            .number()
            .required("O peso é obrigatória"),
        instalacaoId: Yup
            .number()
            .required("O instalação é obrigatória"),

    })

    useEffect(() => {

        if (isEditing) {
            api.get(`empenho/${id}`).then((response) => {

                formik.setFieldValue("empenhoId", response.data.empenhoId);
            });
        }

    }, []);


    const formik = useFormik({

        initialValues: {
            "ativo": false,
            "empenhoAnoRef": null,
            "empenhoId": null,
            "instalacaoId": null,
            "instalacaoNumero": null,
            "numeroEmpenho": null,
            "peso": 1,
            "saldoEmpenho": null
        },

        validationSchema: schema,

        enableReinitialize: false,

        onSubmit: (data) => {

            console.log(data);

            if (isSubmiting) return;

            data.empenhoId = id;

            setIsSubmiting(true)

            setListInstalacaoEmpenho(listInstalacaoEmpenho => [...listInstalacaoEmpenho, data]);


            setIsSubmiting(false)


        }
    })

    const handleChangeInstalacao = (e) => {

        formik.setFieldValue("instalacaoId", e.value);

    }

    const handleGetInstalacoes = useCallback(async () => {

        await api.get("instalacao/instalacaoAll").then((response) => {

            const instalacoes = response.data.map(item => {

                return {
                    id: item.id,
                    numeroInstalacao: item.numeroInstalacao,
                    descricao: item.descricao,
                    endereco: item.endereco,
                    localidade: item.localidade
                }
            });

            setListInstalacao(instalacoes);
        });

    }, [])

    useEffect(async () => {

        await handleGetInstalacoes();

    }, [handleGetInstalacoes]);

    const handleCheckboxChange = (event) => {
        formik.setFieldValue('ativo', event.target.checked);
    };


    return (

        <div style={containerStyle}>
            <Fieldset legend="Instalações" toggleable style={fieldsetStyle}>
                <Toast ref={toast} position="bottom-right" />
                <div className="p-col-12 p-sm-12">
                    <form onSubmit={formik.handleSubmit}>
                        <div className="p-formgrid p-grid p-fluid p-mx-0">

                            <div className="p-field p-col-4 p-sm-5">
                                <label
                                    htmlFor="instalacaoId"
                                    className={classNames({ 'p-error': isFormFieldValid('instalacaoId') })}
                                >
                                    Instalações ....
                                </label>
                                {!isLoading ?
                                    <Dropdown
                                        id="instalacaoId"
                                        name="instalacaoId"
                                        options={listInstalacao}
                                        filter={true}
                                        emptyMessage={"Nenhum instalação encontrado"}
                                        optionValue="id"
                                        optionLabel='numeroInstalacao'
                                        placeholder="Selecione uma instalação"
                                        className={classNames({ 'p-invalid': isFormFieldValid('instalacaoId') })}
                                        value={formik.values.instalacaoId}
                                        onChange={handleChangeInstalacao}
                                        emptyFilterMessage={"Nenhum isntalação encontrada"}
                                        itemTemplate={(option) => (
                                            <table style={{ width: '100%' }}>
                                                <tbody>
                                                    <tr key={option.id}>
                                                        <td style={{ width: '10%', padding: '3px' }}>{option.numeroInstalacao}</td>
                                                        <td style={{ width: '10%', padding: '3px' }}>{option.descricao}</td>
                                                        <td style={{ width: '10%', padding: '3px' }}>{option.endereco}</td>
                                                        <td style={{ width: '10%', padding: '3px' }}>{option.localidade}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        )} />

                                    :
                                    <Skeleton height="35px" />}
                                {formik.errors.instalacaoId && formik.touched.instalacaoId &&
                                    <ErrorValidationMessage message={formik.errors.instalacaoId} />}
                            </div>

                            <div className="p-field p-col-4 p-sm-4">
                                <label
                                    htmlFor="peso"
                                    className={classNames({ 'p-error': isFormFieldValid('peso') })}
                                >
                                    Peso
                                </label>
                                {!isLoading ?
                                    <InputText
                                        id="peso"
                                        name="peso"
                                        type="number"
                                        className={classNames({ 'p-invalid': isFormFieldValid('peso') })}
                                        value={formik.values.peso}
                                        onChange={formik.handleChange} />
                                    :
                                    <Skeleton height="35px" />}
                                {formik.errors.peso && formik.touched.peso &&
                                    <ErrorValidationMessage message={formik.errors.peso} />}
                            </div>

                            <div className="p-field p-col-3 p-sm-2">
                                <label
                                    htmlFor="ativo"
                                    className={classNames({ 'p-error': isFormFieldValid('ativo') })}
                                >
                                    ativo
                                </label>
                                {!isLoading ?

                                    <input type="checkbox" className="table-data" checked={formik.values.ativo} onChange={handleCheckboxChange} />
                                    :
                                    <Skeleton height="35px" />}
                                {formik.errors.ativo && formik.touched.ativo &&
                                    <ErrorValidationMessage message={formik.errors.ativo} />}
                            </div>

                            <div className="p-d-flex p-sm-1">

                                <Button
                                    icon="pi pi-plus"
                                    type="button"
                                    iconPos="right"
                                    onClick={formik.handleSubmit}
                                    loading={isSubmiting} />
                            </div>
                        </div>
                    </form>
                </div>
            </Fieldset>

            <Fieldset legend="Importar de ..." toggleable style={fieldsetStyle}>
                <Toast ref={toast} position="bottom-right" />
                <div className="p-col-12 p-sm-12">
                    <div className="p-formgrid p-grid p-fluid p-mx-0">
                        <div className="p-field p-col-11 p-sm-11">
                            <label htmlFor="importEmpenho">
                                Empenhos para importar
                            </label>
                            {!isLoading ? (
                                <Dropdown
                                    id="importEmpenho"
                                    name="importEmpenho"
                                    options={listEmpenhos}
                                    filter={true}
                                    emptyMessage={"Nenhum empenho encontrado"}
                                    optionLabel="numeroEmpenho"
                                    placeholder="Selecione um empenho para importar"
                                    value={selectedEmpenho}
                                    onChange={(e) => setSelectedEmpenho(e.value)}
                                    emptyFilterMessage={"Nenhum empenho encontrado"}
                                    itemTemplate={(option) => (
                                        <table style={{ width: '100%' }}>
                                            <tbody>
                                                <tr key={option.id}>
                                                    <td style={{ width: '10%', padding: '3px' }}>{option.numeroEmpenho}</td>
                                                    <td style={{ width: '10%', padding: '3px' }}>{option.anoRef}</td>
                                                    <td style={{ width: '20%', padding: '3px' }}>{option.ficha}</td>
                                                    <td style={{ width: '15%', padding: '3px' }}>{option.fonte}</td>
                                                    <td style={{ width: '25%', padding: '3px' }}>{option.valorEmpenho}</td>
                                                    <td style={{ width: '30%', padding: '3px' }}>{option.secretariaId}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    )}
                                />
                            ) : (
                                <Skeleton height="35px" />
                            )}
                        </div>
                        <div className="p-d-flex p-sm-1">
                            <Button
                                icon="pi pi-download"
                                type="button"
                                iconPos="right"
                                onClick={handleImportEmpenho}
                                disabled={!selectedEmpenho}
                                loading={isLoadingInstalacoes}
                            />
                        </div>
                    </div>
                </div>
            </Fieldset>
        </div>
    );
}
